import {
  Controller,
  FieldValues,
  Path,
  PathValue,
  useFormContext,
} from "react-hook-form";
import { useLanguage } from "../../Language";
import * as React from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Link,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { SanitizedHTML } from "../../SanitizedHTML";

export interface FormTextFieldProps<T extends FieldValues> {
  name: Path<T>;
  termsAndConditions: string;
}

export const TermsAndConditions = <T extends FieldValues>({
  name,
  termsAndConditions,
}: FormTextFieldProps<T>) => {
  const { translate } = useLanguage();
  const [openTerms, setOpenTerms] = React.useState<boolean>(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { setValue } = useFormContext<T>();
  return (
    <>
      <Dialog open={openTerms} fullScreen={fullScreen}>
        <DialogTitle>{translate("termsAndConditions")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <SanitizedHTML html={termsAndConditions} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTerms(false)}>
            {translate("close")}
          </Button>
          <Button
            onClick={() => {
              setValue(name, true as PathValue<T, Path<T>>);
              setOpenTerms(false);
            }}
          >
            {translate("agreeButton")}
          </Button>
        </DialogActions>
      </Dialog>
      <Controller
        name={name}
        rules={{
          validate: {
            required: (value) =>
              value === true || translate("obrTermsAndConditionsRequired"),
          },
        }}
        render={({
          field: { value, onChange, onBlur, ref },
          fieldState: { error },
        }) => {
          return (
            <FormControl error={!!error}>
              <FormGroup>
                <FormControlLabel
                  inputRef={ref}
                  onBlur={onBlur}
                  required
                  control={
                    <Checkbox
                      checked={value}
                      formNoValidate={true}
                      onChange={onChange}
                    />
                  }
                  label={
                    <>
                      {translate("obrIAgreeToTermsAndConditions")}{" "}
                      <Link
                        component="button"
                        type="button"
                        onClick={() => setOpenTerms(true)}
                      >
                        {translate("termsAndConditions")}
                      </Link>
                    </>
                  }
                />
              </FormGroup>
              <FormHelperText>{error?.message || " "}</FormHelperText>
            </FormControl>
          );
        }}
      ></Controller>
    </>
  );
};
